import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Table } from "reactstrap";
import { Label } from "reactstrap";
import { queryString } from "../../../utils/queryString";
import { updateLatestItemPrice } from "../../../reducers/adminReducers";
import { toast } from "react-toastify";
import { adminInstance } from "../../../config/axios";
import Loader from "../../loader/loader";

const PriceList = () => {
  const [price, setPrice] = useState();
  const { id: productId } = queryString();
  const dispatch = useDispatch();
  const [productData, setProductData] = useState({});
  const [loading, setLoading] = useState(false);

  const getSingleProductData = async (id) => {
    try {
      setLoading(true);
      const response = await adminInstance().get(
        `api/admin/getProductById/${id}`
      );
      const { code, getProduct } = response.data;
      if (code === 200) {
        setLoading(false);
        setProductData(getProduct);
      } else {
        setProductData({});
        setLoading(false);
        toast.error("Something went wrong to fetch data", { toastId: "error" });
      }
    } catch (error) {
      console.log("Error getting in the fetching Products", error);
    }
  };

  useEffect(() => {
    if (productId) {
      getSingleProductData(productId);
    }
  }, [productId]);

  const handleUpdatePrice = () => {
    const payload = {
      productId,
      productPrice: price > 0 ? Number(price) : 0,
    };
    dispatch(updateLatestItemPrice(payload)).then((res) => {
      if (res?.payload?.resultData?.data?.code === 200) {
        toast.success("Latest Price Updated Succussfully", {
          toastId: "latestPrice",
        });
      }
    });
  };

  const formatedDate = (date) => {
    const formatted = new Date(date).toLocaleString("en-US", {
      timeZone: "UTC",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return formatted;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Container fluid={false}>
          <div
            className="admin-input col-xl-5 col-md-7 mt-4"
            style={{ marginLeft: "110px", marginBottom: "20px" }}>
            <p>Current Product Price : {productData?.price?.toFixed(2) || 0}</p>
          </div>
          <Table bordered style={{ width: "80%", margin: "25px auto" }}>
            <thead style={{ backgroundColor: "#f8f9fa" }}>
              <tr>
                <th style={{ width: "30px" }}>S.No</th>
                <th style={{ width: "100px" }}>Market Name</th>
                <th style={{ width: "100px" }}>Price</th>
                <th style={{ width: "100px" }}>Last Updated Time</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  id: 1,
                  name: "Buff Price",
                  price: productData?.buffPrice || 0,
                },
                // {
                //   id: 2,
                //   name: "Csgoempire Price",
                //   price: productData?.csgoempirePrice || 0,
                // },
                // {
                //   id: 3,
                //   name: "Dmarket Price",
                //   price: productData?.dmarketPrice || 0,
                // },
                // {
                //   id: 4,
                //   name: "Skinbaron Price",
                //   price: productData?.skinbaronPrice || 0,
                // },
                // {
                //   id: 5,
                //   name: "Skinport Price",
                //   price: productData?.skinportPrice || 0,
                // },
                // {
                //   id: 6,
                //   name: "Tradeit Price",
                //   price: productData?.tradeitPrice || 0,
                // },
                // {
                //   id: 7,
                //   name: "Gamerpay Price",
                //   price: productData?.gamerpayPrice || 0,
                // },
              ].map(({ id, name, price }) => (
                <tr key={id}>
                  <td>{id}</td>
                  <td>{name}</td>
                  <td>$ {price}</td>
                  <td>{formatedDate(productData?.lastPriceUpdate)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <p className="text-center mt-4 mb-2">OR</p>

          <div
            className="admin-input col-xl-5 col-md-7"
            style={{ marginLeft: "110px", marginBottom: "20px" }}>
            <Label className="col-form-label pt-0">Update Price Manually</Label>
            <input
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="form-control"
              type="number"
            />
            <button
              onClick={handleUpdatePrice}
              className="btn btn-primary mt-4">
              Update
            </button>
          </div>
        </Container>
      )}
    </>
  );
};

export default PriceList;
